// @flow
import React from "react"
import { branch, renderNothing, compose, type HOC } from "recompose"
import withConnect from "hoc/withConnect"
import { selectModal } from "data/modals/selectors"
import { closeModal } from "data/modals/actions"

const MasterModal = ({ modal, closeModal }) => {
  if (!modal) return

  const Component = modal.type

  return <Component {...modal.data} close={closeModal} />
}

const mapStateToProps = state => ({
  modal: selectModal(state),
})

const mapDispatchToProps = {
  closeModal,
}

const enhancer: HOC<*, {||}> = compose(
  withConnect(mapStateToProps, mapDispatchToProps),
  branch(props => !props.modal, renderNothing),
)

export default enhancer(MasterModal)



// WEBPACK FOOTER //
// ./src/AppComponent/Content/MasterModal/index.js